/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ScheduleType } from '@gh/builder-shared-data';
import { GanttTask } from '@gh/builder-shared-gantt-chart';

@Component({
    selector: 'gh-schedule-gantt-header-dock',
    template: require('./schedule-gantt-header-dock.component.html'),
    styles: [require('../schedule-gantt-details-header-component.scss')],
})
export class ScheduleGanttHeaderDockComponent implements OnChanges {
  @Input() details: any;
  @Input() tasks: GanttTask[];
  @Output() nextUnconfirmedTask = new EventEmitter<any>();
  unconfirmedTaskCount: number = 0;
  unconfirmedSelectedTaskID?: string;

  get isConstruction(): boolean {
    return this.details.type === ScheduleType.Construction;
  }

  get isPreConstruction(): boolean {
    return this.details.type === ScheduleType.PreConstruction;
  }

  get isSales(): boolean {
    return this.details.type === ScheduleType.Sales;
  }

  get isMaintenance(): boolean {
    return this.details.type === ScheduleType.Maintenance;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.tasks) {
      this.unconfirmedTaskCount = this.tasks.filter((task: any) => task.status === 0).length || 0;
    }
  }

  onNextUnconfirmedVariation(): void {
    if (this.nextUnconfirmedTask) {
      const unconfirmedTasks = this.tasks.filter((task: any) => task.status === 0);
      if (this.unconfirmedSelectedTaskID) {
        let currentPos = 0;
        unconfirmedTasks.forEach((task: any, index: number) => {
          if (task.taskId === this.unconfirmedSelectedTaskID) {
            currentPos = index;
          }
        });
        this.unconfirmedSelectedTaskID = unconfirmedTasks[currentPos + 1] ?
          unconfirmedTasks[currentPos + 1].taskId : unconfirmedTasks[0].taskId;
      } else {
        this.unconfirmedSelectedTaskID = unconfirmedTasks[0].taskId;
      }
      this.nextUnconfirmedTask.emit(this.unconfirmedSelectedTaskID);
    }
  }
}
